import * as React from "react";
import { useDispatch } from "react-redux";
import { checklistStepSubmitActionCreator } from "../../../store/actions/checklist";
import { IChecklistEntryStepSubmit } from "../../../types/api.types";
import { ChecklistItem } from "../../../types/checklist.types";
import { ICompartment } from "../../../types/order.types";
import { PreRadioForm } from "../../components/tabbars/cleaningtabs/cleaningtab/compartmenttab/checklist/forms/PreRadioForm";

interface IProps {
    prev: () => void;
    checklistId: number;
    compartment: ICompartment;
    containerLocation?: string;
}

export const PreRadioFormContainer = (props: IProps) => {
    const dispatch = useDispatch();

    const submit = (error: boolean, fields: string, restFound: boolean, restAmount: number, submittedBy?: string, msg?: string) => {
        const checklistEntryStepSubmit: IChecklistEntryStepSubmit = {
            errorDetected: error,
            customerMessage: msg,
            stepOrder: 2,
            checklistItem: ChecklistItem.PRE_OPERATION_CHECKLIST,
            formFields: fields,
            restFound: restFound,
            manualWorkNeeded: false,
            restAmount: restAmount,
            submittedBy: submittedBy
        };

        dispatch(checklistStepSubmitActionCreator({
            checklistId: props.checklistId,
            checklistEntryStepSubmit,
            compartmentId: props.compartment.id
        }));
    };

    const onError = (fields: any, submittedBy: string, msg?: string) => {
        submit(true, JSON.stringify(fields), fields.restFound, fields.restAmount, submittedBy, msg);
    };

    const onOk = (fields: any) => {
        submit(false, JSON.stringify(fields), fields.restFound, fields.restAmount);
    };

    return (
        <PreRadioForm
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onError={onError}
            onOk={onOk}
            prev={props.prev}
            containerLocation={props.containerLocation}
            restFound={props.compartment.restFound}
        />
    );
};
